import { useState } from 'react'
import PropTypes from 'prop-types'
import RadioButton from '@/v3-dashboard/components/UI/RadioButton'
import Button from '@/shared/components/UI/Button'

const REASONS = [
  {
    id: 'expensive',
    label: "It's too expensive",
    description: "The cost doesn't fit my budget right now",
  },
  {
    id: 'novalue',
    label: "I'm not getting enough value",
    description: "It's not solving the problem I hoped it would",
  },
  {
    id: 'timing',
    label: "I don't need it right now",
    description: 'Good product, just not the right time for me',
  },
  {
    id: 'broken',
    label: 'Something is broken / not working',
    description: "I've had technical issues I couldn't resolve",
  },
  {
    id: 'competitor',
    label: "I'm switching to a competitor",
    description: 'I found another tool that fits better',
  },
]

const StepReason = ({ onSelect, isLoading }) => {
  const [selected, setSelected] = useState(null)

  const handleContinue = () => {
    if (selected) onSelect(selected)
  }

  return (
    <div className="flex flex-col gap-v3-md">
      <p className="text-v3-black-secondary text-v3-h9 font-inter-variable">
        This helps us improve Dante and it helps us find the right solution for you.
      </p>

      <div className="flex flex-col gap-v3-xs">
        {REASONS.map((reason) => {
          const isSelected = selected === reason.id
          return (
            <div
              key={reason.id}
              onClick={() => setSelected(reason.id)}
              className={`cursor-pointer rounded-v3-sm border p-v3-sm flex items-start gap-v3-sm transition-colors duration-150 ${
                isSelected
                  ? 'border-v3-purple-primary bg-v3-purple-bg'
                  : 'border-v3-card-border bg-white hover:border-v3-purple-primary'
              }`}
            >
              <div className="mt-[2px] flex-shrink-0">
                <RadioButton
                  name="downgrade-reason"
                  value={reason.id}
                  checked={isSelected}
                  onChange={() => setSelected(reason.id)}
                  size="md"
                />
              </div>
              <div className="flex flex-col gap-[2px]">
                <span className="text-v3-black-max font-medium text-[15px]">
                  {reason.label}
                </span>
                <span className="text-v3-black-secondary text-[13px]">
                  {reason.description}
                </span>
              </div>
            </div>
          )
        })}
      </div>

      <div className='w-full flex items-center justify-end'>
        <Button
          label="Continue"
          variant="primary"
          size="lg"
          disabled={!selected}
          loading={isLoading}
          onClick={handleContinue}
        />
      </div>
    </div>
  )
}

StepReason.propTypes = {
  onSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

StepReason.defaultProps = {
  isLoading: false,
}

export default StepReason
